























































































import VueOptions from '@utils/VueOptions'
import UiList from '@superUI/List/List'
import Modal from '@/components/Modal'
import RequestButton from '@/components/RequestButton'
import Trigger from '@modules/ui/triggers/Trigger'
import ResourceList from '@modules/ui/List/ResourceList'
import LoadingIndicator from '@/components/LoadingIndicator'
import DebugOnly from '@/components/DebugOnly'
import EventService from '@services/EventService'

settings =
  name: 'EventScheduleOfferResourceList'

  vue:
    props: ['offers', 'bulkActionResultItems', 'actions', 'listItemActions', 'filtersOverriden', 'infiniteWrapper', 'options']
    components: {
      DebugOnly,
      UiList,
      Modal,
      RequestButton,
      Trigger,
      ResourceList,
      LoadingIndicator
    }

    data: ->
      activeFilter: false
      pageNumber: 1
      sortList: [
        { field: 'ctx.event.local_start_day', value: 'Event Date' }
        { field: 'ctx.brand.name', value: 'Brand Name' }
        { field: 'ctx.event.name', value: 'Event Name' }
        { field: 'expires_at', value: 'Expiration Date' }
        { field: 'aasm_state', value: 'Status' }
        { field: 'ctx.event.reach', value: 'Reach' }
        { field: 'ctx.event.location.city', value: 'Location' }
        { field: 'buyer_price_in_cents', value: 'buyer_price_in_cents' }
      ]
      sortValue: ''

      filters:
        scopes: {}
        multi_filters: {}

        sort: [
          { field: 'ctx.event.local_start_day', order: 'desc' }
          { field: 'ctx.brand.name', order: 'asc' }
          { field: 'ctx.event.name', order: 'asc' }
          { field: 'expires_at', order: 'desc' }
          { field: 'aasm_state', order: 'asc' }
          { field: 'ctx.event.reach', order: 'asc' }
          { field: 'ctx.event.location.city', order: 'asc' }
          { field: 'buyer_price_in_cents', order: 'asc' }
        ]

      selectedStatusList: []
      selectedFilters: []
      selectedOffers: []

      statusFilterBar:
        width: 0
        left: 0

    created: ->
      @registerEventHandlers()

    mounted: ->
      @filters = @filtersOverriden if @filtersOverriden?
      @loadFiltersFromURL()
      @initializeStatusFilterBar()

      if @$route.query?.purchased
        @showFlash({ Info: 'It might take a few minutes for your offers to be generated.' })
        @$router.replace({ query: null })

    beforeDestroy: ->
      @unregisterEventHandlers()

    computed:
      components: -> 
        { 'event-schedule-offer-resource-list-item' : () => import("./EventScheduleOfferResourceListItem") }

      title: ->
        @options?.title || 'Offers'
      resourceKey: ->
        @options?.resourceKey || 'offers'

      allStatusFilters: ->['submitted', 'accepted', 'denied', 'canceled']

      availableSort: ->
        ctx = this
        availableList = @sortList.filter((sort) ->
          item = ctx.filters.sort.find((item) -> item.field == sort.field)
          !item
        )
        availableList

      selectedSortByName: -> @filters.sort.map (f) -> f.field

      hasOffersBeingGenerated: ->
        return true if not @offers?
        !!@offers.filter((offer) =>
          poLineItems = @ctxPurchaseOrder(offer).line_items or []
          'submitted' is offer.state and not poLineItems.length
        ).length

      displayPendingOffersMessage: ->
        return false unless @offers?
        return true for o in @offers when o.state in ['draft', 'submitted']
        false

    methods:
      registerEventHandlers: ->
        @unregisterEventHandlers()
        EventService.$on('progress-bar-completed', @onProgressBarCompleted);
      unregisterEventHandlers: ->
        EventService.$off('progress-bar-completed', @onProgressBarCompleted)
      onProgressBarCompleted: (bar) ->
        if bar.key.includes('purchase')
          @pageNumber = 1
          @hiInfiniteScroll()

      initializeStatusFilterBar: ->
        @updateStatusFilterBar()

      updateStatusFilterBar: ->
        setTimeout(() =>
          element = document.querySelector('.primary-filter-item.active')
          position = { width: 0, left: 0 }
          position = { width: element.offsetWidth, left: element.offsetLeft } if element
          @statusFilterBar = position
        , 0)

      sortFilterForName: (name) -> @filters.sort.find (f) -> f.field is name

      hiInfiniteScroll: (state) ->
        @actions.fetchResource(state, @resourceKey, @formatFiltersPayload(), { page: @pageNumber })
        @pageNumber += 1

      setFilters: (selectedFilters) ->
        @$refs.infiniteLoading.stateChanger.reset()
        @selectedFilters = selectedFilters if selectedFilters
        @pageNumber = 1
        @actions.fetchResource(null, @resourceKey, @formatFiltersPayload(), { page: @pageNumber })
        @pageNumber += 1

      hiStatusFilterChange: (filterName) ->
        if 'all' is filterName
          @selectedStatusList = []
        else
          @selectedStatusList = [filterName]

        @updateStatusFilterBar()
        @updateFiltersOnURL()
        @setFilters()

      hiFilterChange: ->
        @updateFiltersOnURL()
        @setFilters()

      updateFiltersOnURL: ->
        status = @selectedStatusList.join(',')
        @$router.push({ query: { status }})

      loadFiltersFromURL: ->
        queryStatus = @$route.query?.status || ''
        statusList = (status for status in queryStatus.split(',') when status isnt '')
        @selectedStatusList = statusList if statusList.length

      formatFiltersPayload: ->
        payload = {...@filters}
        timeWindows = payload.time_windows

        payload.filters = payload.filters || {}
        for field, timeWindow of timeWindows
          payload.filters["#{field}_before"] = timeWindow.before if timeWindow.before
          payload.filters["#{field}_after"] = timeWindow.after if timeWindow.after

        payload.multi_filters.any_state = @selectedStatusList
        delete payload.multi_filters.any_state if !@selectedStatusList.length
        payload

      hiSearchChange: (q = '') ->
        @filters.q = q
        @setFilters(@filters)
      hiClearFilter: ->
        cleared_filter_scope = @filters.scopes
        Object.keys(cleared_filter_scope).forEach((key) -> cleared_filter_scope[key] = null)
        @selectedFilters = []
        @setFilters(@filters)
      hiAddSort: (order) ->
        return false if !@sortValue.length
        @filters.sort.push({ field: @sortValue, order })
        @setFilters()
        @sortValue = ''
      hiRemoveSort: (sort) ->
        @filters.sort = @filters.sort.filter((item) -> item.field != sort.field)
        @setFilters(@filters)
      toggleSortOrder: (sort) -> 
        newOrder = if sort.order == 'asc' then 'desc' else 'asc'
        @filters.sort = @filters.sort.filter((item) ->
          item.order = newOrder if item.field == sort.field
          item
        )
      hiFlipOrder: (sort) ->
        @toggleSortOrder(sort)
        @setFilters(@filters)

      hiToggleAndUpdateSort: (sort) ->
        @toggleSortOrder(sort)
        @pushSortOrder(sort)
        @setFilters(@filters)

      pushSortOrder: (sort) -> 
        otherFilters = @filters.sort.filter (f) -> f.field isnt sort.field
        sortFilters = []
        sortFilters.push(sort)
        if sort.field is 'aasm_state' # always sort by aasm_status AND date when sorting by status
          otherFilters = otherFilters.filter (f) -> f.field isnt 'expires_at'
          sortFilters.push @sortFilterForName('expires_at')
        sortFilters = sortFilters.concat(otherFilters)
        @filters.sort = sortFilters

      sortOrderArrowIcon: (order) ->
        if order == 'asc'
          return 'fa-arrow-up'
        return 'fa-arrow-down'
      sortOrderCaretIcon: (order) ->
        return 'fa-caret-up' if order is 'asc'
        return 'fa-caret-down'
      getFieldName: (field) -> @sortList.find((item) -> item.field == field).value

      hiClearAllFilters: ->
        @selectedStatusList = []
        @setFilters()

      hiExportCSV: ->
        @actions.exportOffersCSVTrigger()

export default VueOptions.vue settings
